module.exports = __webpack_public_path__ + "static/media/ginecologica.4b0ac24d.svg";